import { render, staticRenderFns } from "./authSucc.vue?vue&type=template&id=3279321a&scoped=true"
import script from "./authSucc.vue?vue&type=script&lang=js"
export * from "./authSucc.vue?vue&type=script&lang=js"
import style0 from "./authSucc.vue?vue&type=style&index=0&id=3279321a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3279321a",
  null
  
)

export default component.exports